<template>
  <div class="fund-wallet-modal">
    <div class="connection-list-wrapper fund">
      <div
        data-w-id="9749f7e2-5d03-6905-2e47-60e928926444"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="div-block-52 connection">
        <h1 class="modal-heading connection">
          Withdrawal amount
        </h1>
      </div>
      <div class="connections fund">
        <input
          type="text"
          class="text-field-3 w-input"
          maxlength="256"
          name="field"
          data-name="Field"
          placeholder="Enter amount"
          id="field"
          required=""
          v-model="withdrawModel.payOutAmount"
        />
        <BaseComponentLoader
          v-if="loader.nonBlockingLoader"
          loaderAlignment="center"
        />
        <div
          v-else
          data-w-id="1b3d4daf-0a70-8b14-8027-e7299cdd755a"
          class="button-15 w-button"
          @click="createPayOut"
        >
          Proceed
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PayOutRequest from "@/model/requests/PayOutRequest";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "WithdrawModal",
  components: { BaseComponentLoader },
  data() {
    return {
      withdrawModel: PayOutRequest.create
    };
  },
  props: {
    cancel: Function,
    closeModal: Function
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    }),
    ...mapState(["loader"])
  },
  methods: {
    createPayOut() {
      this.withdrawModel.payOutCustomerId = this.userInfo.customerId;
      StoreUtils.dispatch("payOut/createPayOut", this.withdrawModel).then(
        () => {
          this.closeModal();
        }
      );
    }
  }
};
</script>

<style scoped></style>
